import React from 'react';
import AuthorizationHelper from 'packages/helpers/AuthorizationHelper';
import permissions from 'packages/configs/permissions';
import PointerAction from 'packages/common/editor/timeline/timeline-actions/components/PointerAction';
import GroupAction from 'packages/common/editor/timeline/timeline-actions/components/GroupAction';
import UngroupAction from 'packages/common/editor/timeline/timeline-actions/components/UngroupAction';
import ComponentAction from 'packages/common/editor/timeline/timeline-actions/components/ComponentAction';
import VisibilityAction from 'packages/common/editor/timeline/timeline-actions/components/VisibilityAction';
import LockAction from 'packages/common/editor/timeline/timeline-actions/components/LockAction';
import DuplicateAction from 'packages/common/editor/timeline/timeline-actions/components/DuplicateAction';
import DeleteAction from 'packages/common/editor/timeline/timeline-actions/components/DeleteAction';
import { TimelineActionsWrapper } from './TimelineActions.styled';

export const TimelineActions = () => (
    <TimelineActionsWrapper>
        <PointerAction />
        <GroupAction />
        <UngroupAction />
        {AuthorizationHelper.hasPermission(permissions.COMPONENTS.WRITE) && <ComponentAction />}
        <VisibilityAction />
        <LockAction />
        <DuplicateAction />
        <DeleteAction />
    </TimelineActionsWrapper>
);
